import { history } from 'router/history';
import { MARKETS_REPORTS_PATH } from 'features/insights/consts/routes';
import { generatePath } from 'react-router-dom';
import { OVERVIEW_REPORT_NAME } from 'utils/navigation/navigation-consts';
import type { Filter } from '@placer-ui/types';
import { FilterInsights } from 'core/entities/filter';
import { getFiltersForUrl } from 'router/utils/filters/filters';
import { updatedMarketURLSignal } from 'features/insights/components/compare-bar/compare-bar-signals';

export type GoToMarketsPageParams = {
    id: string;
    collection: string;
    competitor?: string;
    filters?: Filter[] | FilterInsights[];
    section?: string;
    newTab?: boolean;
};

export const goToMarketsPage = ({
    id,
    collection,
    section = OVERVIEW_REPORT_NAME,
    newTab,
    competitor,
    filters = [] as GoToMarketsPageParams['filters'],
}: GoToMarketsPageParams) => {
    const filtersForUrl = getFiltersForUrl(filters);

    const path = generatePath(MARKETS_REPORTS_PATH, {
        id,
        collection,
        section,
    });
    const search = new URLSearchParams();
    if (competitor) {
        search.set('competitor', competitor);
    }
    if (filtersForUrl && filtersForUrl.length > 0) {
        search.set('filter', JSON.stringify(filtersForUrl));
    }

    const queryString = search.toString() ? `?${search.toString()}` : '';

    if (newTab) {
        window.open(`${path}${queryString}`);
    } else {
        updatedMarketURLSignal.value = `${path}?${search.toString()}`;
        history.push({
            pathname: path,
            search: search.toString(),
        });
    }
};
